import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";

const FloatingText = ({ text, color = "green" }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(false), 1200);
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return (
    <Wrapper $color={color}>
      <Text $color={color}>{text}</Text>
    </Wrapper>
  );
};

export default FloatingText;

const floatUp = keyframes`
  0% {
    opacity: 0;
    transform: translate(-50%, 20px) scale(0.7);
  }
  20% {
    opacity: 1;
    transform: translate(-50%, -10px) scale(1.1);
  }
  40% {
    transform: translate(-50%, -20px) scale(1);
  }
  80% {
    opacity: 1;
    transform: translate(-50%, -40px) scale(1);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -60px) scale(0.9);
  }
`;

const Wrapper = styled.div`
  position: fixed;
  top: 45%;
  left: 50%;
  z-index: 1001;
  pointer-events: none;
  animation: ${floatUp} 1.2s ease-out forwards;
`;

const Text = styled.div`
  font-size: 26px;
  font-weight: 900;
  text-align: center;
  white-space: nowrap;
  color: ${({ $color }) => ($color === "red" ? "#dc2626" : "#16a34a")};
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
`;
